
<template>
  <div class="settings-tab">
    <div class="tab-head">
      <img v-if="img != 'pressure'" :src="`https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/${img}.png`" />
      <img v-else src="@/assets/pressure.png" />
      <h5 v-html="title"></h5>
    </div>
    <div class="tab-content" v-if="type === 'text'">
      <div v-for="c in content">
        <h5 v-html="c">{{c}}</h5>
      </div>
    </div>
    <div class="tab-content" v-else style="margin-right:10px;">
      <div :class="content.active ? 'tab-tog' : 'tab-tog inactive-tog'">
        <h4>{{content.left}}</h4>
        <div class="tog-switch" @click="toggle()">
          <div :class="content.ticked ? 'settings-tog tog-ticked' : 'settings-tog tog-unticked'"></div>
        </div>
        <h4>{{content.right}}</h4>
      </div>
    </div>
  </div>

</template>

<script>

import { mapState } from 'vuex';

export default {

  data(){
    return {}
  },

  computed: mapState({
    lang: state => state.room
  }),

  props: ['img', 'title', 'type', 'content'],

  methods: {

    toggle(){
      if (['units', 'pressure'].includes(this.img)) {
        if (Math.floor(Date.now()/1000) >= this.$store.state.sessionEnd) {
          this.$store.dispatch('logoutNotif');
          this.$router.push({path: '/'});
        } else {
          this.$store.dispatch('loadingOn');
          this.$store.dispatch('togUnits', this.img == 'pressure');
          this.$emit('switchToggle', this.img);
          this.$store.dispatch('togSettings');
          setTimeout(() => {
            this.$store.dispatch('loadingOff');
          }, 3000);
        }
      } else if (this.img === 'lang') {
        if (Math.floor(Date.now()/1000) >= this.$store.state.sessionEnd) {
          this.$store.dispatch('logoutNotif');
          this.$router.push({path: '/'});
        } else {
          this.$store.dispatch('loadingOn');
          let lang = this.content.ticked ? 'en' : 'jp';
          this.$store.dispatch('switchRestLang', lang);
          this.content.ticked = this.lang === 'jp' ? true : false;
          this.$emit('switchToggle', 'lang');
          this.$store.dispatch('togSettings');
          setTimeout(() => {
            this.$store.dispatch('loadingOff');
          }, 3000);
        }
      }
    }

  },

  mounted(){

  }

}

</script>

<style>

.settings-tab {
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid lightgray;
  margin-top: 10px;
  margin-bottom: 10px;
}

.tab-head {
  width: 25%;
  height: 75%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.tab-head img {
  height: 50%;
}

.settings-tab h5 {
  margin: 2px;
  font-weight: lighter;
}

.tab-head h5 {
  color: #4077BE;
  text-align: center;
}

.tab-content {
  width: 70%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  color: #1d1d20;
}

.tab-tog {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.tab-tog h4 {
  width: 30%;
  font-weight: lighter;
  text-align: center;
}

.tog-switch {
  width: 60px;
  height: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 2px solid #1d1d20;
  border-radius: 30px;
  margin-left: 20px;
  margin-right: 20px;
  padding-left: 5px;
  padding-right: 5px;
  cursor: pointer;
}

.settings-tog {
  width: 20px;
  height: 20px;
  background-color: #1d1d20;
  border-radius: 100%;
  display: flex;
}

.tab-tog h4 {
  font-size: .75em;
  width: 22.5%;
}

.tog-ticked {
  align-self: flex-end;
}

.tog-unticked {
  align-self: flex-start;
}

.inactive-tog h4 {
  color: gray;
}

.inactive-tog .tog-switch {
  border: 2px solid gray;
}

.inactive-tog .tog-unticked {
  background-color: gray;
}

</style>



// WEBPACK FOOTER //
// src/components/settings/Tab.vue